/**
 * 🌾 TIER 3 BUILDINGS - Agriculture & Settlement
 * 
 * Unlocked by: Agriculture, Construction, Storage
 * Cost multiplier: 6.25x | Prod multiplier: 2.56x
 * Costs: 300-600 | Production: 1.0-1.5/s
 * Target ROI: ~2 minutes
 */

export const TIER_03_BUILDINGS = {
  farm: {
    id: 'farm',
    name: 'Farm',
    icon: '🌾',
    tier: 3,
    description: 'Grows crops for sustenance',
    flavor: 'From tiny seeds grow mighty civilizations.',
    baseCost: { wood: 250, stone: 125 },
    baseProduction: { food: 1.3 },
    unlockCondition: { tech: 'agriculture' },
  },

  windmill: {
    id: 'windmill',
    name: 'Windmill',
    icon: '🌬️',
    tier: 3,
    description: 'Processes grain efficiently',
    flavor: 'Let the wind do the work.',
    baseCost: { wood: 375, stone: 220 },
    baseProduction: { food: 1.5 },
    unlockCondition: { tech: 'agriculture' },
  },

  lumberCamp: {
    id: 'lumberCamp',
    name: 'Lumber Camp',
    icon: '🪓',
    tier: 3,
    description: 'Harvests nearby forests for timber',
    flavor: 'Where axes ring and forests fall to progress.',
    baseCost: { wood: 300, stone: 200 },
    baseProduction: { wood: 1.4 },
    unlockCondition: { tech: 'agriculture' },
  },

  granary: {
    id: 'granary',
    name: 'Granary',
    icon: '🏚️',
    tier: 3,
    description: 'Stores and distributes food',
    flavor: 'A full granary means a happy populace.',
    baseCost: { wood: 310, stone: 190 },
    baseProduction: { food: 1.0, population: 0.25 },
    unlockCondition: { tech: 'storage' },
  },

  house: {
    id: 'house',
    name: 'House',
    icon: '🏠',
    tier: 3,
    description: 'Basic housing for families',
    flavor: 'Home is where the hearth is.',
    baseCost: { wood: 220, stone: 125 },
    baseProduction: { population: 0.5 },
    unlockCondition: { tech: 'construction' },
  },

  cottage: {
    id: 'cottage',
    name: 'Cottage',
    icon: '🏡',
    tier: 3,
    description: 'Comfortable rural dwelling',
    flavor: 'A cozy cottage in the countryside.',
    baseCost: { wood: 310, stone: 190 },
    baseProduction: { population: 0.75 },
    unlockCondition: { tech: 'construction' },
  },
};

export default TIER_03_BUILDINGS;